
/* STUDIO DÉCO — SWATCHES COLLECTION V3 */

(() => {
  'use strict';

  function getCard(button) {
    return button.closest('product-grid-item');
  }

  function getVisibleVariant(card) {
    return [...card.querySelectorAll('product-grid-item-variant')]
      .find(item => !item.hidden);
  }

  function getImageContainer(card) {
    const variant = getVisibleVariant(card);
    return variant ? variant.querySelector('[data-grid-images]') : null;
  }

function showImage(card, button, useHoverImage = false) {
      const container = getImageContainer(card);
    if (!container || !button) return;

const url = useHoverImage
  ? button.dataset.hoverImage || button.dataset.image
  : button.dataset.image;
      if (!url) return;

    let preview = container.querySelector('.sd-card-swatch-preview');

    if (!preview) {
      preview = document.createElement('img');
      preview.className = 'sd-card-swatch-preview';
      preview.alt = '';
      preview.setAttribute('aria-hidden', 'true');

      const original = container.querySelector('img');
      if (original) {
        preview.style.objectFit = getComputedStyle(original).objectFit;
      }

      container.style.position = 'relative';
      container.appendChild(preview);
    }

    preview.src = url;
    preview.hidden = false;
  }

  function updateLinks(card, button) {
    const url = button.dataset.productUrl;
    if (!url) return;

    const variant = getVisibleVariant(card);

    if (variant) {
      variant.querySelectorAll('[data-grid-link]').forEach(link => {
        link.href = url;
      });

      const discover = variant.querySelector('.sd-card-actions__discover');
      if (discover) discover.href = url;

      const favorite = variant.querySelector('[data-sd-favorite]');
      if (favorite) {
        favorite.dataset.productId = button.dataset.productId;
        favorite.dataset.productUrl = url;
        favorite.dataset.productTitle =
          button.getAttribute('aria-label') || 'Tapis';
      }
    }


const infoLink = card.querySelector('.product__grid__info [data-grid-link]');
if (infoLink) infoLink.href = url;

/* SD — Actualiser le titre selon le coloris choisi */
const selectedTitle = button.getAttribute('aria-label');

const titleElement = card.querySelector(
  '.sd-product-card-meta .product__grid__title'
);

if (titleElement && selectedTitle) {
  titleElement.textContent = selectedTitle;
}

if (infoLink && selectedTitle) {
  infoLink.setAttribute('aria-label', selectedTitle);
}

if (window.SDFavorites) {
  window.SDFavorites.refresh();
}

  }

  function selectSwatch(button) {
    const card = getCard(button);
    if (!card) return;

    const group = button.closest('[data-sd-card-swatches]');
    if (!group) return;

    group.querySelectorAll('[data-sd-card-swatch]').forEach(item => {
      const selected = item === button;
      item.classList.toggle('is-selected', selected);
      item.setAttribute('aria-pressed', String(selected));
    });

    showImage(card, button);
    updateLinks(card, button);
  }


function previewTitle(card, button) {
  const title = card.querySelector(
    '.sd-product-card-meta .product__grid__title'
  );

  const name = button?.getAttribute('aria-label');

  if (title && name) {
    title.textContent = name;
  }
}

function restoreSelected(card) {
  const selected = card.querySelector(
    '[data-sd-card-swatches] .sd-card-swatch.is-selected'
  );

  if (!selected) return;

  const isOriginalProduct =
    selected.dataset.productId === card.dataset.itemId;

  if (isOriginalProduct) {
    card.querySelectorAll('.sd-card-swatch-preview').forEach(preview => {
      preview.remove();
    });
  } else {
    showImage(card, selected);
  }

  previewTitle(card, selected);
}


  document.addEventListener('click', event => {
    const more = event.target.closest('[data-sd-swatches-more]');

    if (more) {
      event.preventDefault();
      event.stopPropagation();

      const group = more.closest('[data-sd-card-swatches]');
      if (!group) return;

      const expanded = more.getAttribute('aria-expanded') === 'true';

      group.querySelectorAll('.sd-card-swatch--extra').forEach(item => {
        item.hidden = expanded;
      });

      more.setAttribute('aria-expanded', String(!expanded));
      more.textContent = expanded ? '+' + group.querySelectorAll(
        '.sd-card-swatch--extra'
      ).length : '−';

      return;
    }

    const button = event.target.closest('[data-sd-card-swatch]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    selectSwatch(button);
  });

  document.addEventListener('pointerover', event => {
    if (!window.matchMedia('(hover: hover)').matches) return;

    const button = event.target.closest('[data-sd-card-swatch]');
    if (!button) return;

    const card = getCard(button);
if (card) {
  showImage(card, button);
  previewTitle(card, button);
}  });

  document.addEventListener('pointerout', event => {
    const button = event.target.closest('[data-sd-card-swatch]');
    if (!button) return;

    if (button.contains(event.relatedTarget)) return;

    const card = getCard(button);
    if (card) restoreSelected(card);
  });

  /* Photo d'ambiance du coloris sélectionné */
document.addEventListener('pointerover', event => {
  if (!window.matchMedia('(hover: hover)').matches) return;
  if (!(event.target instanceof Element)) return;

  const container = event.target.closest('[data-grid-images]');
  if (!container) return;
  if (
    event.relatedTarget instanceof Node &&
    container.contains(event.relatedTarget)
  ) return;

  const card = container.closest('product-grid-item');
  if (!card) return;

  const selected = card.querySelector(
    '[data-sd-card-swatches] .sd-card-swatch.is-selected'
  );

  if (!selected) return;

  /* Le produit d'origine conserve le survol natif de Pipeline */
  if (selected.dataset.productId === card.dataset.itemId) return;

  showImage(card, selected, true);
});

document.addEventListener('pointerout', event => {
  if (!(event.target instanceof Element)) return;

  const container = event.target.closest('[data-grid-images]');
  if (!container) return;
  if (
    event.relatedTarget instanceof Node &&
    container.contains(event.relatedTarget)
  ) return;

  const card = container.closest('product-grid-item');
  if (card) restoreSelected(card);
});
})();
